import { tagged } from "@mirage/service-logging";
import {
  getAllDNPPreferences,
  setDNPPreference,
} from "@mirage/service-notifications";
import Sentry from "@mirage/shared/sentry";
import { useCallback, useEffect, useState } from "react";

const logger = tagged("useNotificationSettings");

export const useNotificationSettings = () => {
  const [stackSharedSubscribed, _setStackSharedSubscribed] = useState<
    boolean | null
  >(null);

  useEffect(() => {
    getAllDNPPreferences()
      .then((dnpPreferences) => {
        dnpPreferences?.forEach((pref) => {
          if (
            pref.dnp_category_id?.[".tag"] ===
            "dnp_category_feature_stack_shared"
          ) {
            if (pref.is_subscribed !== undefined) {
              _setStackSharedSubscribed(pref.is_subscribed);
            }
          }
        });
      })
      .catch((e) => {
        logger.error("Failed to refresh notifications", e);
        Sentry.captureException(e, {
          data: {
            message: "Failed to fetch notifications preferences",
          },
        });
      });
  }, []);

  const setStackSharedSubscribed = useCallback((isSubscribed: boolean) => {
    _setStackSharedSubscribed(isSubscribed);
    setDNPPreference("feature_stack_shared", isSubscribed);
  }, []);

  return stackSharedSubscribed !== null
    ? {
        available: true as const,
        stackSharedSubscribed,
        setStackSharedSubscribed,
      }
    : { available: false as const };
};
